import styled from "@emotion/styled";
import { Col, Row, Table } from "antd";
import { CustomButon } from "./CommonHeader";
import touzi4 from "../../../../images/touzi-4.png";
import jiansheImg from "../../../../images/jianshe-4.png";
import jianshebox from "../../../../images/jianshe-box.png";
import jiansheActive from "../../../../images/jianshe-item.png";
import th from "../../../../images/th1.png";
import tr from "../../../../images/tr.png";
import { ColumnsType } from "antd/es/table/interface";
import YearPicker from "../../../../components/YearPicker";
import xiangmuImg from "../../../../images/xiangmu-6.png";
import { DualAxes } from "@ant-design/plots";
import line3 from "../../../../images/line3.png";
import { useCallback, useEffect, useState } from "react";
import request from "../../../../utils/request";
import done from "../../../../images/status/done.png";
import doing from "../../../../images/status/doing.png";
import close from "../../../../images/status/close.png";
import liuzhuan from "../../../../images/status/liuzhuan.png";
const statusMapping: any = {
  0: {
    icon: doing,
    color: "#5498F8",
  },
  1: {
    icon: done,
    color: "#1CFBFF",
  },
  2: {
    icon: liuzhuan,
    color: "#5498F8",
  },

  3: {
    icon: done,
    color: "#91989B",
  },
  4: {
    icon: liuzhuan,
    color: "#D59648",
  },
};
const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .base-info-btn {
    color: #fff;
    font-weight: bold;
    font-size: 20px;

    align-items: center;
    img {
      margin-right: 5px;
    }
    span {
      margin-left: 8px;
    }
  }
  .table-wrapper {
    margin-top: 33px;
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
      display: none;
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    /* tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
        padding: 16px 0px !important;
      }
    } */
    tbody tr {
      background-image: none !important;
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }
`;

export const FangKui: React.FC<{
  id?: number;
}> = ({ id }) => {
  const [details, setDetails] = useState<Record<string, any>[]>([]);

  const getData = useCallback(() => {
    if (!id) return;
    request
      .get("/screen/company/getCompanyQuestion?comid=" + id)
      .then((res) => {
        setDetails(res.data?.data || []);
        // setDetails([{}, {}, {}, {}]);
      });
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      width: "30px",
      align: "left",
      render(value, _, index) {
        return (
          <img
            style={{
              width: "16px",
              height: "16px",
            }}
            src={statusMapping[_.status].icon}
          />
        );
      },
    },
    {
      title: "走访人",
      align: "left",
      dataIndex: "numbers",
      render(value, _) {
        return (
          <div
            style={{
              marginLeft: "-24px",
            }}
          >
            <div
              style={{
                color: "#fff",
                marginLeft: "-8px",
              }}
            >
              【{_.cate_name}】{_.title}
            </div>
            <div
              style={{
                fontSize: 12,
              }}
            >
              {_.numbers}
            </div>
          </div>
        );
      },
    },
    {
      title: "走访时间",
      align: "left",
      dataIndex: "sq",
      render(value, _) {
        return (
          <div>
            <div
            // style={{
            //   color: "#fff",
            // }}
            >
              来自
            </div>
            <div
            // style={{
            //   fontSize: 12,
            // }}
            >
              {_.source_name}
            </div>
          </div>
        );
      },
    },
    {
      title: "走访结果",
      align: "center",
      dataIndex: "title",
      render(value, _) {
        return (
          <div>
            <div
            // style={{
            //   color: "#fff",
            // }}
            >
              {_.company_name}
            </div>
            <div
            // style={{
            //   fontSize: 12,
            // }}
            >
              {_.creator_name} {_.createtime}
            </div>
          </div>
        );
      },
    },
    {
      title: "操作",
      align: "center",
      dataIndex: "month",
      render(value, _) {
        return (
          <div>
            <div
            // style={{
            //   color: "#fff",
            // }}
            >
              {_.creator_name}
              <span
                style={{
                  color: statusMapping[_.status].color,
                  marginLeft: "6px",
                }}
              >
                {_.flow_status}
              </span>
            </div>
            <div
            // style={{
            //   fontSize: 12,
            // }}
            >
              {_.flow_time}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <Layout>
      <div className="box-item table-box">
        <div className="base-info-btn flex">
          <img src={line3} width="7" height="21" alt="" />
          <span>诉求反馈</span>
        </div>
        <div className="table-wrapper">
          <Table
            columns={columns}
            pagination={false}
            dataSource={details}
            locale={{
              emptyText: "暂无数据",
            }}
          />
        </div>
      </div>
    </Layout>
  );
};
